module.exports = __webpack_public_path__ + "static/media/moth-home-poster.2bfe4d71.png";